import toast from "react-hot-toast";
import COMMON_FIELDS from "../constants/commonFields";
import HTTP_STATUSES from "../constants/http/httpStatuses";

export enum ERROR_HANDLER_SERVICE_TYPE {
	"FULL_MODE" = "1",
	"SHARED_MODE" = "2",
}

type errorHandlerServiceProps = {
	[COMMON_FIELDS.STATUS]: number;
	[COMMON_FIELDS.DATA]: string;
};

type errorHandlerServicePropsType = {
	[COMMON_FIELDS.TYPE]: ERROR_HANDLER_SERVICE_TYPE;
};

export const isErrorHandlerService = ({
	[COMMON_FIELDS.DATA]: error,
	[COMMON_FIELDS.STATUS]: status,
}: errorHandlerServiceProps) => {
	return error && status;
};

export const errorHandlerService = ({
	[COMMON_FIELDS.DATA]: error,
	[COMMON_FIELDS.STATUS]: status,
	[COMMON_FIELDS.TYPE]: type,
}: errorHandlerServiceProps & errorHandlerServicePropsType) => {
	if (
		process.env.REACT_APP_MODE === "DEVELOP" &&
		process.env.REACT_APP_OFF_LOG_WINDOWS !== "true"
	) {
		if (
			isErrorHandlerService({
				[COMMON_FIELDS.DATA]: error,
				[COMMON_FIELDS.STATUS]: status,
			}) &&
			!(status === HTTP_STATUSES.BAD_REQUEST)
		) {
			toast.error(
				type === ERROR_HANDLER_SERVICE_TYPE.FULL_MODE
					? error
					: `${error}-${status}`
			);
		}
	}
};
